/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSalesInvoiceOrderNumberDto
 */
export interface GetSalesInvoiceOrderNumberDto {
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceOrderNumberDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoiceOrderNumberDto
     */
    lp: number;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceOrderNumberDto
     */
    orderNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceOrderNumberDto
     */
    orderDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceOrderNumberDto
     */
    salesInvoiceId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceOrderNumberDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetSalesInvoiceOrderNumberDto interface.
 */
export function instanceOfGetSalesInvoiceOrderNumberDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lp" in value;
    isInstance = isInstance && "orderNumber" in value;
    isInstance = isInstance && "orderDate" in value;
    isInstance = isInstance && "salesInvoiceId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetSalesInvoiceOrderNumberDtoFromJSON(json: any): GetSalesInvoiceOrderNumberDto {
    return GetSalesInvoiceOrderNumberDtoFromJSONTyped(json, false);
}

export function GetSalesInvoiceOrderNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSalesInvoiceOrderNumberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lp': json['lp'],
        'orderNumber': json['orderNumber'],
        'orderDate': (json['orderDate'] === null ? null : new Date(json['orderDate'])),
        'salesInvoiceId': json['salesInvoiceId'],
        'active': json['active'],
    };
}

export function GetSalesInvoiceOrderNumberDtoToJSON(value?: GetSalesInvoiceOrderNumberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lp': value.lp,
        'orderNumber': value.orderNumber,
        'orderDate': (value.orderDate === null ? null : value.orderDate.toISOString()),
        'salesInvoiceId': value.salesInvoiceId,
        'active': value.active,
    };
}

